import { useSelectedNode } from "./useSelectedNode";

interface IUseIssueType {
  issueType: string;
  lastIssueTypeLabel: string | undefined;
}

export const useIssueType = (): IUseIssueType => {
  const { level1Node, level2Node, level3Node, level4Node, level5Node } =
    useSelectedNode();
  let issueType = "";
  let lastIssueTypeLabel = undefined;

  const nodes = [level1Node, level2Node, level3Node, level4Node, level5Node];
  for (const node of nodes) {
    if (!node) {
      break;
    }
    issueType += `${node.id}-`;
    lastIssueTypeLabel = node.label;
  }

  const issueTypeWithoutEndingDash = issueType.substring(
    0,
    issueType.length - 1
  );
  return {
    issueType: issueTypeWithoutEndingDash,
    lastIssueTypeLabel,
  };
};
